/*
 * Bot messages are stored as HTML - bold, italic and links written in the node
 * editor. Wherever the dashboard shows one formatted, it goes through here
 * first: the markup comes from whoever edits the bot, and is not trusted.
 */

const ALLOWED_TAGS = ['STRONG', 'B', 'EM', 'I', 'U', 'A', 'BR'];
export const SAFE_URL = /^(https?:|mailto:|tel:)/i;

/*
 * Written into a message as they are and replaced by the backend with the
 * visitor's name (ConditionedWords). They look like tags but are text: stored
 * unescaped, and shown as written wherever the message is shown.
 */
export const PLACEHOLDERS = ['<first_name>', '<last_name>'];
export const PLACEHOLDER_PATTERN = /<(first_name|last_name)>/g;

/*
 * Keeps only the formatting the node editor can produce. Any other element is
 * replaced by its text, attributes other than a link's address are dropped,
 * and a link that is not http(s), mailto or tel loses its address.
 */
export const sanitizeHtml = (html) => {
    if (!html || typeof DOMParser === 'undefined') return '';

    // as text, not as unknown elements that would be dropped
    const protectedHtml = html.replace(PLACEHOLDER_PATTERN, '&lt;$1&gt;');
    const doc = new DOMParser().parseFromString(`<div>${protectedHtml}</div>`, 'text/html');
    const root = doc.body.firstChild;

    const clean = (node) => {
        Array.from(node.childNodes).forEach((child) => {
            if (child.nodeType === 3) return; // text

            if (child.nodeType !== 1 || ALLOWED_TAGS.indexOf(child.tagName) === -1) {
                const isDropped = child.nodeType !== 1 || ['SCRIPT', 'STYLE'].indexOf(child.tagName) !== -1;
                child.replaceWith(doc.createTextNode(isDropped ? '' : child.textContent));
                return;
            }

            const href = child.tagName === 'A' ? child.getAttribute('href') : null;
            Array.from(child.attributes).forEach((attr) => child.removeAttribute(attr.name));

            if (href && SAFE_URL.test(href.trim())) {
                child.setAttribute('href', href.trim());
                child.setAttribute('target', '_blank');
                child.setAttribute('rel', 'noopener noreferrer');
            }

            clean(child);
        });
    };

    clean(root);
    return root.innerHTML;
};



// WEBPACK FOOTER //
// ./src/utils/Html.js